import { Injectable } from "@angular/core";

/** Exposes whether any units of work have changes */
@Injectable({providedIn: 'root'})
export class HasChangesService {
  hasChanges = false;
}
